// extracted by mini-css-extract-plugin
module.exports = {"textArea":"_DocumentTextArea_textArea__3mwaK","right":"_DocumentTextArea_right__H9S3_"};